(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lc-athletes-new"] && !Shopify.designMode) return;
  try {
    
(function () {
  function cartRoute(p) {
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return base.replace(/\/$/, '') + p;
  }
  function initSection(root) {
    if (root.__lcAth) return;
    root.__lcAth = true;
    var row = root.querySelector('[data-lc-ath-row]');
    var prev = root.querySelector('[data-lc-ath-prev]');
    var next = root.querySelector('[data-lc-ath-next]');

    // Reveal toggles
    Array.prototype.forEach.call(root.querySelectorAll('[data-lc-ath-card]'), function (card) {
      var t = card.querySelector('[data-lc-ath-toggle]');
      if (t) t.addEventListener('click', function () {
        var open = card.classList.toggle('is-open');
        t.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    // Add-the-stack
    Array.prototype.forEach.call(root.querySelectorAll('[data-lc-ath-addstack]'), function (btn) {
      btn.addEventListener('click', function () {
        var ids = (btn.getAttribute('data-variant-ids') || '').split(',').filter(Boolean);
        if (!ids.length) return;
        var label = btn.querySelector('[data-lc-ath-cta-label]');
        var original = label ? label.textContent : '';
        btn.disabled = true;
        if (label) label.textContent = 'Adding…';
        fetch(cartRoute('/cart/add.js'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: ids.map(function (id) { return { id: parseInt(id, 10), quantity: 1 }; }) })
        })
          .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
          .then(function () {
            if (label) label.textContent = 'Added ✓';
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            try { if (window.Shopify && window.Shopify.PubSub) window.Shopify.PubSub.publish('cart:update', { source: 'lc-athletes' }); } catch (e) {}
            setTimeout(function () { if (label) label.textContent = original; btn.disabled = false; }, 1600);
          })
          .catch(function () {
            if (label) label.textContent = 'Try again';
            setTimeout(function () { if (label) label.textContent = original; btn.disabled = false; }, 1800);
          });
      });
    });

    // Arrows
    function scrollByCard(dir) {
      if (!row) return;
      var card = row.querySelector('.lc-ath__card');
      var amount = card ? card.getBoundingClientRect().width + 16 : row.clientWidth * 0.8;
      row.scrollBy({ left: dir * amount, behavior: 'smooth' });
    }
    function updateArrows() {
      if (!row || !prev || !next) return;
      prev.disabled = row.scrollLeft <= 4;
      next.disabled = row.scrollLeft >= (row.scrollWidth - row.clientWidth - 4);
    }
    if (prev) prev.addEventListener('click', function () { scrollByCard(-1); });
    if (next) next.addEventListener('click', function () { scrollByCard(1); });
    if (row) { row.addEventListener('scroll', updateArrows, { passive: true }); updateArrows(); }
    window.addEventListener('resize', updateArrows);
  }
  function boot() { Array.prototype.forEach.call(document.querySelectorAll('.lc-ath'), initSection); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lc-product-reveal"] && !Shopify.designMode) return;
  try {
    
(function(){
  function clamp(v,a,b){return Math.max(a,Math.min(b,v));}
  function init(root){
    if(root.dataset.ready) return; root.dataset.ready='1';
    var track=root.querySelector('.lc-rev__track'), bar=root.querySelector('.lc-rev__bar');
    var sticky=root.querySelector('.lc-rev__sticky');
    var steps=[].slice.call(root.querySelectorAll('.lc-rev__step')), dots=[].slice.call(root.querySelectorAll('.lc-rev__dots b'));
    var frames=[].slice.call(root.querySelectorAll('.lc-rev__frame'));
    var liquid=root.querySelector('.lc-rev__liquid'), drop=root.querySelector('.lc-rev__drop'), mark=root.querySelector('.lc-rev__mark');
    var LIQ_BOT=396, LIQ_H=292;
    function setStep(i){steps.forEach(function(s,j){s.classList.toggle('is-active',j===i);});dots.forEach(function(d,j){d.classList.toggle('is-active',j===i);});}
    function fill(f){if(liquid){var h=f*LIQ_H;liquid.setAttribute('y',LIQ_BOT-h);liquid.setAttribute('height',h);}if(mark)mark.setAttribute('opacity',(0.22+0.62*clamp((f-0.4)/0.6,0,1)).toFixed(3));}
    if(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches){root.classList.add('is-static');if(steps.length)setStep(steps.length-1);fill(1);return;}
    function update(p){
      if(frames.length){var idx=Math.round(p*(frames.length-1));frames.forEach(function(f,i){f.classList.toggle('is-active',i===idx);});}
      else{var dp=clamp(p/0.55,0,1),y=96+dp*150,op=dp<0.12?dp/0.12:(dp>0.9?(1-(dp-0.9)/0.1):1);if(drop){drop.setAttribute('transform','translate(0,'+y+')');drop.setAttribute('opacity',clamp(op,0,1).toFixed(3));}fill(clamp((p-0.08)/0.80,0,1));}
      if(steps.length)setStep(Math.min(steps.length-1,Math.floor(p*steps.length+0.0001)));
      if(bar)bar.style.transform='scaleX('+p.toFixed(4)+')';
    }
    var inView=false, ticking=false;
    function onScroll(){
      if(!inView||ticking) return; ticking=true;
      requestAnimationFrame(function(){
        // progress 0→1 across the stretch where the sticky panel is pinned
        var r=track.getBoundingClientRect(), sh=sticky?sticky.offsetHeight:window.innerHeight, total=track.offsetHeight-sh;
        update(clamp(-r.top/(total||1),0,1)); ticking=false;
      });
    }
    new IntersectionObserver(function(es){es.forEach(function(e){inView=e.isIntersecting;if(inView)onScroll();});},{threshold:0}).observe(track);
    window.addEventListener('scroll',onScroll,{passive:true});
    window.addEventListener('resize',onScroll);
    if(steps.length)setStep(0); update(0);
  }
  function boot(){document.querySelectorAll('[data-lc-rev]').forEach(init);}
  if(document.readyState!=='loading') boot(); else document.addEventListener('DOMContentLoaded',boot);
  document.addEventListener('shopify:section:load',boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lc-quiz"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initQuiz(root) {
    if (!root || root.__lcQuiz) return;
    root.__lcQuiz = true;

    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-lc-quiz-panel], [data-lc-quiz-result]'));
    var questionPanels = Array.prototype.slice.call(root.querySelectorAll('[data-lc-quiz-panel="q"]'));
    var progress = root.querySelector('[data-lc-quiz-progress]');
    var fill = root.querySelector('[data-lc-quiz-fill]');
    var stepLabel = root.querySelector('[data-lc-quiz-steplabel]');
    var startBtn = root.querySelector('[data-lc-quiz-start]');
    var addToCart = root.getAttribute('data-add-to-cart') === 'true';
    var total = questionPanels.length;

    var scores = {};
    var primaryKey = null;
    var current = 0; // 0 = intro
    var displayMode = root.getAttribute('data-display') || 'inline';
    var isPopup = displayMode === 'popup';

    function show(panel) {
      panels.forEach(function (p) { p.classList.remove('is-active'); });
      panel.classList.add('is-active');
      var focusable = panel.querySelector('button, a');
      if (focusable) { try { focusable.focus({ preventScroll: true }); } catch (e) {} }
      if (!isPopup) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function showQuestion(n) {
      current = n;
      var panel = questionPanels[n - 1];
      if (progress) progress.hidden = false;
      if (fill) fill.style.width = ((n - 1) / total * 100) + '%';
      if (stepLabel) stepLabel.textContent = 'Question ' + n + ' of ' + total;
      show(panel);
    }

    function addScores(str, primary) {
      (str || '').split(',').forEach(function (pair) {
        var kv = pair.split(':');
        var key = (kv[0] || '').trim();
        var val = parseInt(kv[1], 10) || 0;
        if (!key) return;
        scores[key] = (scores[key] || 0) + val;
      });
      if (primary) primaryKey = primary;
    }

    function computeWinner() {
      var best = null, bestScore = -1;
      Object.keys(scores).forEach(function (k) {
        if (scores[k] > bestScore) { best = k; bestScore = scores[k]; }
      });
      // Tie-break: if the Q1 primary ties the leader, prefer it.
      if (primaryKey && scores[primaryKey] === bestScore) best = primaryKey;
      return best || primaryKey || 'vitality';
    }

    function showResult() {
      if (progress) { fill.style.width = '100%'; progress.hidden = true; }
      var key = computeWinner();
      var panel = root.querySelector('[data-lc-quiz-result="' + key + '"]');
      if (!panel) panel = root.querySelector('[data-lc-quiz-result]'); // fallback: first result
      show(panel);
    }

    function selectOption(btn) {
      var panel = btn.closest('[data-lc-quiz-panel="q"]');
      Array.prototype.forEach.call(panel.querySelectorAll('.lc-quiz__opt'), function (o) { o.classList.remove('is-selected'); });
      btn.classList.add('is-selected');
      addScores(btn.getAttribute('data-scores'), btn.getAttribute('data-primary'));
      var qn = parseInt(panel.getAttribute('data-q'), 10);
      window.setTimeout(function () {
        if (qn >= total) showResult();
        else showQuestion(qn + 1);
      }, 180);
    }

    function reset() {
      scores = {};
      primaryKey = null;
      current = 0;
      Array.prototype.forEach.call(root.querySelectorAll('.lc-quiz__opt.is-selected'), function (o) { o.classList.remove('is-selected'); });
      if (progress) progress.hidden = true;
      if (fill) fill.style.width = '0%';
      show(root.querySelector('[data-lc-quiz-panel="intro"]'));
    }

    function cartRoute(path) {
      var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return base.replace(/\/$/, '') + path;
    }

    function addVariant(btn) {
      var id = btn.getAttribute('data-variant-id');
      var fallback = btn.getAttribute('data-fallback');
      if (!addToCart) { if (fallback) window.location.href = fallback; return; }
      var label = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding…';
      fetch(cartRoute('/cart/add.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () {
          btn.textContent = 'Added ✓';
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          try { if (window.Shopify && window.Shopify.PubSub) window.Shopify.PubSub.publish('cart:update', { source: 'lc-quiz' }); } catch (e) {}
          setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1600);
        })
        .catch(function () {
          if (fallback) { window.location.href = fallback; return; }
          btn.textContent = 'Try again';
          setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1800);
        });
    }

    if (startBtn) startBtn.addEventListener('click', function () { showQuestion(1); });
    Array.prototype.forEach.call(root.querySelectorAll('[data-lc-quiz-opt]'), function (btn) {
      btn.addEventListener('click', function () { selectOption(btn); });
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-lc-quiz-restart]'), function (btn) {
      btn.addEventListener('click', reset);
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-lc-quiz-add]'), function (btn) {
      btn.addEventListener('click', function () { addVariant(btn); });
    });

    // ---- Popup mode ----
    if (isPopup) {
      var QUIZ_KEY = 'lc_quiz_seen';
      var freqDays = parseInt(root.getAttribute('data-freq-days'), 10) || 0;
      var anchor = root.getAttribute('data-anchor') || 'lc-quiz';

      function seenRecently() {
        if (freqDays <= 0) return false;
        try {
          var ts = parseInt(window.localStorage.getItem(QUIZ_KEY), 10);
          return ts && ((Date.now() - ts) / 86400000) < freqDays;
        } catch (e) { return false; }
      }
      function markSeen() { try { window.localStorage.setItem(QUIZ_KEY, String(Date.now())); } catch (e) {} }

      function openPopup() {
        reset();
        root.hidden = false;
        document.documentElement.style.overflow = 'hidden';
      }
      function closePopup() {
        root.hidden = true;
        document.documentElement.style.overflow = '';
      }

      // Any [data-lc-quiz-open] element, or any link to #anchor, opens the quiz.
      document.addEventListener('click', function (e) {
        var trigger = e.target.closest('[data-lc-quiz-open], a[href="#' + anchor + '"]');
        if (trigger) { e.preventDefault(); openPopup(); }
      });
      var backdrop = root.querySelector('[data-lc-quiz-backdrop]');
      var closeBtn = root.querySelector('[data-lc-quiz-close]');
      if (backdrop) backdrop.addEventListener('click', closePopup);
      if (closeBtn) closeBtn.addEventListener('click', closePopup);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hidden) closePopup(); });

      if (root.getAttribute('data-auto') === 'true' && !seenRecently()) {
        var delay = parseFloat(root.getAttribute('data-delay')) || 0;
        window.setTimeout(function () { openPopup(); markSeen(); }, delay * 1000);
      }
    }
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-lc-quiz]'), initQuiz);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lc-scratch"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initScratch(root) {
    if (!root || root.__lcScratch) return;
    root.__lcScratch = true;

    var cfg = {
      delay: parseFloat(root.getAttribute('data-delay')) || 0,
      freqDays: parseInt(root.getAttribute('data-freq-days'), 10) || 0,
      scope: root.getAttribute('data-scope') || 'all',
      suppressKnown: root.getAttribute('data-suppress-known') === 'true',
      debug: root.getAttribute('data-debug') === 'true',
      threshold: (parseInt(root.getAttribute('data-threshold'), 10) || 55) / 100,
      closeBackdrop: root.getAttribute('data-close-backdrop') === 'true',
      confetti: root.getAttribute('data-confetti') === 'true',
      surfaceColor: root.getAttribute('data-surface-color') || '#CCBAA2',
      surfaceLabel: root.getAttribute('data-surface-label') || '',
      surfaceGradient: root.getAttribute('data-surface-gradient') === 'true',
      surfaceColor2: root.getAttribute('data-surface-color2') || '#124734',
      surfaceAngle: parseInt(root.getAttribute('data-surface-angle'), 10) || 135,
      surfaceSheen: root.getAttribute('data-surface-sheen') === 'true',
      klaviyoMode: root.getAttribute('data-klaviyo-mode') || 'open',
      klaviyoForm: root.getAttribute('data-klaviyo-form') || ''
    };

    var STORAGE_KEY = 'lc_scratch_seen';
    var modal = root.querySelector('.lc-scratch__modal');
    var canvas = root.querySelector('[data-lc-scratch-canvas]');
    var stage = root.querySelector('[data-lc-scratch-stage]');
    var hint = root.querySelector('[data-lc-scratch-hint]');
    var revealBtn = root.querySelector('[data-lc-scratch-reveal]');
    var revealBlock = root.querySelector('[data-lc-scratch-revealblock]');
    var closeBtn = root.querySelector('[data-lc-scratch-close]');
    var backdrop = root.querySelector('[data-lc-scratch-backdrop]');
    var openBtn = root.querySelector('[data-lc-scratch-open]');

    var revealed = false;
    var scratching = false;
    var ctx = null;

    function seenRecently() {
      if (cfg.freqDays <= 0) return false;
      try {
        var raw = window.localStorage.getItem(STORAGE_KEY);
        if (!raw) return false;
        var ts = parseInt(raw, 10);
        if (!ts) return false;
        var days = (Date.now() - ts) / 86400000;
        return days < cfg.freqDays;
      } catch (e) { return false; }
    }
    function markSeen() {
      try { window.localStorage.setItem(STORAGE_KEY, String(Date.now())); } catch (e) {}
    }

    function onHomepage() {
      return location.pathname === '/' || location.pathname === '';
    }

    function angleGradient(c, w, h, deg, c1, c2) {
      var rad = ((deg % 360) + 360) % 360 * Math.PI / 180;
      var cx = w / 2, cy = h / 2;
      var len = (Math.abs(w * Math.cos(rad)) + Math.abs(h * Math.sin(rad))) / 2;
      var dx = Math.cos(rad) * len, dy = Math.sin(rad) * len;
      var g = c.createLinearGradient(cx - dx, cy - dy, cx + dx, cy + dy);
      g.addColorStop(0, c1);
      g.addColorStop(1, c2);
      return g;
    }

    function drawSheen(c, w, h) {
      var g = c.createLinearGradient(0, 0, w, h);
      g.addColorStop(0, 'rgba(255,255,255,0)');
      g.addColorStop(0.42, 'rgba(255,255,255,0.05)');
      g.addColorStop(0.5, 'rgba(255,255,255,0.24)');
      g.addColorStop(0.58, 'rgba(255,255,255,0.05)');
      g.addColorStop(1, 'rgba(255,255,255,0)');
      c.fillStyle = g;
      c.fillRect(0, 0, w, h);
    }

    function paintSurface() {
      if (!canvas || !stage) return;
      var rect = stage.getBoundingClientRect();
      var dpr = window.devicePixelRatio || 1;
      canvas.width = Math.round(rect.width * dpr);
      canvas.height = Math.round(rect.height * dpr);
      ctx = canvas.getContext('2d');
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      if (cfg.surfaceGradient) {
        ctx.fillStyle = angleGradient(ctx, rect.width, rect.height, cfg.surfaceAngle, cfg.surfaceColor, cfg.surfaceColor2);
      } else {
        ctx.fillStyle = cfg.surfaceColor;
      }
      ctx.fillRect(0, 0, rect.width, rect.height);
      if (cfg.surfaceSheen) drawSheen(ctx, rect.width, rect.height);
      if (cfg.surfaceLabel) {
        ctx.fillStyle = 'rgba(255,255,255,0.85)';
        ctx.font = '600 13px "Helvetica Neue", Helvetica, Arial, sans-serif';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        var letters = cfg.surfaceLabel.toUpperCase().split('').join('\u2009');
        ctx.fillText(letters, rect.width / 2, rect.height / 2);
      }
    }

    function pointerPos(e) {
      var rect = canvas.getBoundingClientRect();
      var x = (e.touches ? e.touches[0].clientX : e.clientX) - rect.left;
      var y = (e.touches ? e.touches[0].clientY : e.clientY) - rect.top;
      return { x: x, y: y };
    }

    function scratchAt(p) {
      if (!ctx) return;
      ctx.globalCompositeOperation = 'destination-out';
      ctx.beginPath();
      ctx.arc(p.x, p.y, 22, 0, Math.PI * 2);
      ctx.fill();
    }

    var checkCount = 0;
    function maybeCheckCleared() {
      checkCount++;
      if (checkCount % 6 !== 0) return;
      if (!ctx) return;
      var rect = stage.getBoundingClientRect();
      var dpr = window.devicePixelRatio || 1;
      try {
        var img = ctx.getImageData(0, 0, Math.round(rect.width * dpr), Math.round(rect.height * dpr));
        var data = img.data;
        var clear = 0;
        var total = 0;
        for (var i = 3; i < data.length; i += 40) { // sample alpha channel
          total++;
          if (data[i] === 0) clear++;
        }
        if (total && (clear / total) >= cfg.threshold) reveal();
      } catch (e) {}
    }

    function reveal() {
      if (revealed) return;
      revealed = true;
      if (canvas) canvas.classList.add('is-cleared');
      if (hint) hint.classList.add('is-hidden');
      if (revealBlock) revealBlock.hidden = false;
      if (cfg.confetti && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) burstConfetti();
      // Embed mode: Klaviyo populates the embedded form automatically once visible.
    }

    function openKlaviyo() {
      if (!cfg.klaviyoForm) return;
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', cfg.klaviyoForm]);
    }

    function burstConfetti() {
      var colors = ['#124734', '#CCBAA2', '#F4EFE3', '#FB9A2D'];
      var cx = window.innerWidth / 2;
      var cy = window.innerHeight / 2;
      for (var i = 0; i < 28; i++) {
        (function () {
          var el = document.createElement('div');
          el.className = 'lc-scratch__confetti-piece';
          el.style.background = colors[i % colors.length];
          el.style.left = cx + 'px';
          el.style.top = cy + 'px';
          document.body.appendChild(el);
          var angle = Math.random() * Math.PI * 2;
          var dist = 80 + Math.random() * 160;
          var dx = Math.cos(angle) * dist;
          var dy = Math.sin(angle) * dist + 120;
          var rot = (Math.random() * 720 - 360) + 'deg';
          el.animate(
            [
              { transform: 'translate(0,0) rotate(0)', opacity: 1 },
              { transform: 'translate(' + dx + 'px,' + dy + 'px) rotate(' + rot + ')', opacity: 0 }
            ],
            { duration: 900 + Math.random() * 500, easing: 'cubic-bezier(0.2,0.7,0.3,1)' }
          ).onfinish = function () { el.remove(); };
        })();
      }
    }

    function bindScratch() {
      if (!canvas) return;
      function down(e) { scratching = true; scratchAt(pointerPos(e)); e.preventDefault(); }
      function move(e) { if (!scratching) return; scratchAt(pointerPos(e)); maybeCheckCleared(); e.preventDefault(); }
      function up() { scratching = false; maybeCheckCleared(); }
      canvas.addEventListener('mousedown', down);
      canvas.addEventListener('mousemove', move);
      window.addEventListener('mouseup', up);
      canvas.addEventListener('touchstart', down, { passive: false });
      canvas.addEventListener('touchmove', move, { passive: false });
      canvas.addEventListener('touchend', up);
    }

    function open() {
      root.hidden = false;
      markSeen(); // write on show, not on close
      document.documentElement.style.overflow = 'hidden';
      // Paint after layout settles so the square has real dimensions.
      requestAnimationFrame(function () { requestAnimationFrame(paintSurface); });
    }
    function close() {
      root.hidden = true;
      document.documentElement.style.overflow = '';
    }

    function schedule() {
      window.setTimeout(open, cfg.delay * 1000);
    }

    function maybeShow() {
      if (cfg.debug) { schedule(); return; }
      if (cfg.scope === 'home' && !onHomepage()) return;
      if (seenRecently()) return;
      if (cfg.suppressKnown && window.klaviyo && typeof window.klaviyo.isIdentified === 'function') {
        try {
          Promise.resolve(window.klaviyo.isIdentified()).then(function (id) { if (!id) schedule(); });
        } catch (e) { schedule(); }
      } else {
        schedule();
      }
    }

    // Wiring
    bindScratch();
    if (revealBtn) revealBtn.addEventListener('click', reveal);
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (openBtn) openBtn.addEventListener('click', openKlaviyo);
    if (backdrop && cfg.closeBackdrop) backdrop.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hidden) close(); });
    window.addEventListener('resize', function () { if (!root.hidden && !revealed) paintSurface(); });

    maybeShow();
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-lc-scratch]'), initScratch);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lc-ugc-feed"] && !Shopify.designMode) return;
  try {
    
(function () {
  function cartRoute(p) {
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return base.replace(/\/$/, '') + p;
  }
  function loadSources(video) {
    if (video.dataset.lcLoaded) return;
    video.dataset.lcLoaded = '1';
    Array.prototype.forEach.call(video.querySelectorAll('source[data-src]'), function (s) {
      s.src = s.getAttribute('data-src');
    });
    video.load();
  }

  function initCard(card) {
    if (card.__lcUgc) return;
    card.__lcUgc = true;
    var video = card.querySelector('[data-lc-ugc-video]');
    var play = card.querySelector('[data-lc-ugc-play]');
    var mute = card.querySelector('[data-lc-ugc-mute]');
    if (!video) return;

    function start() {
      loadSources(video);
      video.muted = true;
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
      card.classList.add('is-playing');
      if (mute) mute.hidden = false;
    }
    function stop() { video.pause(); }

    if (play) play.addEventListener('click', start);
    video.addEventListener('click', function () {
      if (video.paused) { start(); } else { stop(); card.classList.remove('is-playing'); }
    });
    if (mute) mute.addEventListener('click', function () {
      video.muted = !video.muted;
      mute.setAttribute('aria-label', video.muted ? 'Unmute' : 'Mute');
      var ico = mute.querySelector('[data-lc-ugc-mute-ico]');
      if (ico) ico.style.opacity = video.muted ? '1' : '0.55';
    });
    card.__lcStart = start;
    card.__lcStop = stop;
    card.__lcVideo = video;
  }

  function initSection(root) {
    if (root.__lcUgcSec) return;
    root.__lcUgcSec = true;

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-lc-ugc-card]'));
    cards.forEach(initCard);

    // Quick add-to-cart (single-variant products; multi-variant fall back to a PDP link in markup)
    Array.prototype.forEach.call(root.querySelectorAll('[data-lc-ugc-add]'), function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var id = btn.getAttribute('data-variant-id');
        var fallback = btn.getAttribute('data-fallback');
        var label = btn.querySelector('[data-lc-ugc-add-label]');
        var original = label ? label.textContent : '';
        btn.disabled = true;
        if (label) label.textContent = 'Adding…';
        fetch(cartRoute('/cart/add.js'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
        })
          .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
          .then(function () {
            if (label) label.textContent = 'Added ✓';
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            try { if (window.Shopify && window.Shopify.PubSub) window.Shopify.PubSub.publish('cart:update', { source: 'lc-ugc' }); } catch (err) {}
            setTimeout(function () { if (label) label.textContent = original; btn.disabled = false; }, 1600);
          })
          .catch(function () {
            if (fallback) { window.location.href = fallback; return; }
            if (label) label.textContent = 'Try again';
            setTimeout(function () { if (label) label.textContent = original; btn.disabled = false; }, 1800);
          });
      });
    });

    if (root.getAttribute('data-autoplay') === 'true' && 'IntersectionObserver' in window
        && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var card = e.target;
          if (e.isIntersecting && e.intersectionRatio > 0.6) { if (card.__lcStart) card.__lcStart(); }
          else if (card.__lcStop) card.__lcStop();
        });
      }, { threshold: [0, 0.6] });
      cards.forEach(function (c) { io.observe(c); });
    }

    // Always pause a playing video when it scrolls fully out of view (saves bandwidth).
    if ('IntersectionObserver' in window) {
      var pauseIo = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (!e.isIntersecting && e.target.__lcStop) e.target.__lcStop(); });
      }, { threshold: 0 });
      cards.forEach(function (c) { pauseIo.observe(c); });
    }
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-lc-ugc]'), initSection); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
